import script from "./file-select.vue?vue&type=script&setup=true&lang=js"
export * from "./file-select.vue?vue&type=script&setup=true&lang=js"

import "./file-select.vue?vue&type=style&index=0&id=0f8a7b7a&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f8a7b7a"]])

export default __exports__